import { ClockHistory, Search, ToggleOff, ToggleOn } from 'react-bootstrap-icons';

import { PagesBulkPublishModal } from './PagesBulkPublish';
import { PagesSearchAndReplaceForm, PagesSearchAndReplaceHistory } from './PagesSearchAndReplace';
import { PagesMassAction } from './pagesMassActions.types';

export const PAGES_MASS_ACTIONS: PagesMassAction[] = [
  {
    key: 'searchAndReplace',
    icon: <Search />,
    label: 'Знайти та замінити',
    renderModal: ({ siteId, controls }) => <PagesSearchAndReplaceForm siteId={siteId} controls={controls} />,
    extra: {
      key: 'searchAndReplaceHistory',
      icon: <ClockHistory />,
      tooltip: 'Історія пошуку та заміни',
      renderModal: ({ siteId, controls }) => <PagesSearchAndReplaceHistory siteId={siteId} controls={controls} />,
    },
  },
  {
    key: 'publishPages',
    icon: <ToggleOn />,
    label: 'Опублікувати сторінки',
    renderModal: ({ siteId, controls }) => <PagesBulkPublishModal siteId={siteId} action="publish" controls={controls} />,
  },
  {
    key: 'unpublishPages',
    icon: <ToggleOff />,
    label: 'Зняти сторінки з публікації',
    renderModal: ({ siteId, controls }) => <PagesBulkPublishModal siteId={siteId} action="unpublish" controls={controls} />,
  },
];
